import React, { useEffect, useState, useRef } from "react";
import TopHeader from "../component/TopHeader";
import Secondheader from "../component/Second_header";
import ServiceRequestItem3 from "../component/ServiceRequestitem3";
import PopupComponent from "../component/PopupComponent";
import axios from "axios";
import "../component/css/ServiceRequest.css";
import { Menu, MenuItem, Button } from "@mui/material";

const ServiceRequest = () => {
  const [serviceRequestsData, setServiceRequestsData] = useState([]);
  const [serviceTotal, setServiceTotal] = useState([]);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [filter, setFilter] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const dataFetchedRef = useRef(false);
  const [sortedServiceRequests, setSortedServiceRequests] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [subAnchorEl, setSubAnchorEl] = useState(null);

  const handleCreateServiceRequestClick = () => {
    if (!isPopupOpen) {
      setIsPopupOpen(true);
    }
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    fetchData();
  };

  const customerEmail = sessionStorage.getItem("email");

  useEffect(() => {
    if (!dataFetchedRef.current) {
      fetchData();
      dataFetchedRef.current = true;
    }
  }, []);

  //new logic with pagination

  const fetchData = async () => {
    setLoading(true);
    const apiUrl = "/server/jad_group_website_function/service_request";
    const params = {
      Customer_Email: customerEmail,
      Page: currentPage,
      perPage: recordsPerPage === "all" ? 0 : parseInt(recordsPerPage),
    };

    try {
      const response = await axios.get(apiUrl, { params });
      const { data } = response;

      setTotalPages(data.totalPages || 1);
      setServiceRequestsData(data["Service Requests"]);
      setSortedServiceRequests(data["Service Requests"]);
      setServiceTotal(data["Total Service Requests"]);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, recordsPerPage]);

  useEffect(() => {
    let sortedData = [...serviceRequestsData];

    if (filter === "Machine Name") {
      sortedData.sort((a, b) =>
        sortOrder === "A-Z"
          ? a["Machine Name"].localeCompare(b["Machine Name"])
          : b["Machine Name"].localeCompare(a["Machine Name"])
      );
    } else if (filter === "Service Request Number") {
      sortedData.sort((a, b) =>
        sortOrder === "Oldest First"
          ? a["Serial No"] - b["Serial No"]
          : b["Serial No"] - a["Serial No"]
      );
    }

    setSortedServiceRequests(sortedData);
  }, [serviceRequestsData, filter, sortOrder]);

  const handleRecordsPerPageChange = (e) => {
    setRecordsPerPage(e.target.value);
    setCurrentPage(1);
  };
  const handlePageChange = (direction) => {
    if (direction === "next" && currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    } else if (direction === "prev" && currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleSortOrderSelect = (order) => {
    setSortOrder(order);
    handleCloseMenu();
  };

  const handleFilterSelect = (filterType, event) => {
    setFilter(filterType);
    setSubAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSubAnchorEl(null);
  };

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <div className="CMAMachines_box">
      <TopHeader />
      <div className="secondHeader-fixed-style">
        <Secondheader />
      </div>
      <div className="Service_top">
        <div className="Group_a">
          <h1>
            <b>Service</b> Request
          </h1>
          <button
            className="Create-Service-Request"
            onClick={handleCreateServiceRequestClick}
          >
            + Create Service Request
          </button>
          {isPopupOpen && (
            <PopupComponent
              onClose={handleClosePopup}
              isPopupOpen={isPopupOpen}
              email={customerEmail}
            />
          )}
        </div>
        <div className="Group_a Groups_record">
          <div>
            <p className="TotalRecords">Total Records {serviceTotal}</p>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "40%",
              alignItems: "center",
            }}
          >
            <Button
              sx={{
                border: "1px solid #017CC2",
                borderRadius: "1px ",
                backgroundColor: "#017CC2",
                color: "white",
                textTransform: "none",
              }}
              onClick={handleOpenMenu}
            >
              Sort ⮁
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
            >
              <MenuItem
                onClick={(event) => handleFilterSelect("Machine Name", event)}
              >
                Machine Name
              </MenuItem>
              <MenuItem
                onClick={(event) =>
                  handleFilterSelect("Service Request Number", event)
                }
              >
                Service Request Number
              </MenuItem>
            </Menu>
            {filter && (
              <Menu
                anchorEl={subAnchorEl}
                open={Boolean(subAnchorEl)}
                onClose={handleCloseMenu}
              >
                {filter === "Machine Name" ? (
                  <>
                    <MenuItem onClick={() => handleSortOrderSelect("A-Z")}>
                      A-Z Order
                    </MenuItem>
                    <MenuItem onClick={() => handleSortOrderSelect("Z-A")}>
                      Z-A Order
                    </MenuItem>
                  </>
                ) : (
                  <>
                    <MenuItem
                      onClick={() => handleSortOrderSelect("Oldest First")}
                    >
                      Oldest First
                    </MenuItem>
                    <MenuItem
                      onClick={() => handleSortOrderSelect("Newest First")}
                    >
                      Newest First
                    </MenuItem>
                  </>
                )}
              </Menu>
            )}

            <select
              name="recordsPerPage"
              id="recordsPerPage"
              value={recordsPerPage}
              onChange={handleRecordsPerPageChange}
            >
              <option value="all">Show All Records</option>
              <option value="10">10 Records per page</option>
              <option value="50">50 Records Per Page</option>
              <option value="100">100 Records Per Page</option>
            </select>
          </div>
        </div>

        {loading ? (
          <div className="loader" style={{ marginTop: "15%" }}></div>
        ) : sortedServiceRequests.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '80px 20px',
            color: '#666',
            backgroundColor: '#fff',
            margin: '20px 0',
            borderRadius: '10px',
            boxShadow: '0px 0px 20px 1px #c8c8c85c',
          }}>
            <div style={{ fontSize: '64px', color: '#d0d6df', marginBottom: '12px' }}>📋</div>
            <h2 style={{ color: '#145C91', margin: '0 0 10px 0', fontFamily: 'Open Sans, sans-serif' }}>
              No service requests found
            </h2>
            <p style={{ color: '#808490', fontSize: '14px', margin: 0, fontFamily: 'Open Sans, sans-serif' }}>
              You don't have any service requests yet. Click "Create Service Request" to get started.
            </p>
          </div>
        ) : (
          <div className="sr-table-container">
            <table className="sr-table">
              <colgroup>
                <col className="col-srno" />
                <col className="col-desc" />
                <col className="col-machine" />
                <col className="col-type" />
                <col className="col-status" />
                <col className="col-date" />
              </colgroup>
              <thead>
                <tr className="sr-table-header">
                  <th>SR No.</th>
                  <th>Description</th>
                  <th>Machine Name</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {sortedServiceRequests.map((request, index) => (
                  <ServiceRequestItem3
                    key={index}
                    srNo={request["Serial No"]}
                    description={request["Description"]}
                    machineName={request["Machine Name"]}
                    type={request["Type"]}
                    status={request["Status"]}
                    Time={request["Time"]}
                    Recordid={request["Record Id"]}
                  />
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Pagination at bottom */}
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "15px 0",
          gap: "10px",
        }}>
          <button
            style={{
              border: "1px solid",
              borderRadius: "50%",
              backgroundColor: "transparent",
              fontSize: "15px",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
            onClick={() => handlePageChange("prev")}
            disabled={currentPage === 1}
          >
            &#11164;
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            style={{
              border: "1px solid",
              borderRadius: "50%",
              backgroundColor: "transparent",
              fontSize: "15px",
              cursor: currentPage >= totalPages ? "not-allowed" : "pointer",
            }}
            onClick={() => handlePageChange("next")}
            disabled={currentPage >= totalPages || totalPages === 0}
          >
            &#11166;
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceRequest;
